'use client'

import { useState } from 'react'
import Link from 'next/link'
import { ChevronRight, Home } from 'lucide-react'
import { HttpTypes } from '@medusajs/types'

interface Categoria extends Omit<HttpTypes.StoreProductCategory, "category_children"> {
  category_children?: Categoria[] | null
}

const CatalogoMenu: React.FC<{ product_categories: Categoria[]; onClose?: () => void }> = ({ product_categories, onClose }) => {
  const [ruta, setRuta] = useState<Categoria[]>([])

  const categoriaActual = ruta[ruta.length - 1]
  const categoriasAMostrar = categoriaActual?.category_children?.length
    ? categoriaActual.category_children
    : product_categories.filter(cat => !cat.parent_category_id)

  const manejarClickCategoria = (categoria: Categoria) => {
    if (categoria.category_children?.length) {
      setRuta([...ruta, categoria])
    }
  }

  const cerrarMenu = () => {
    onClose?.()
  }

  return (
    <div className="overflow-x-hidden scrollbar-hide">
      {/* Breadcrumb / Back navigation */}
      {ruta.length > 0 && (
        <div className="flex flex-wrap gap-2 mb-4 px-2">
          <button
            onClick={() => setRuta([])}
            className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-gray-100 hover:bg-gray-200 text-sm text-gray-700"
          >
            <Home className="w-4 h-4" />
            Inicio
          </button>
          {ruta.map((cat, index) => (
            <div key={cat.id} className="flex items-center gap-1">
              <ChevronRight className="w-4 h-4 text-gray-400" />
              <button
                onClick={() => setRuta(ruta.slice(0, index))}
                className={`text-sm ${index === ruta.length - 1 ? 'font-semibold text-pink-600' : 'text-gray-600 hover:text-pink-600'}`}
              >
                {cat.name}
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Categories list */}
      <ul className="space-y-2">
        {categoriasAMostrar.map((cat) => (
          <li key={cat.id}>
            {cat.category_children?.length ? (
              <button
                onClick={() => manejarClickCategoria(cat)}
                className="w-full flex justify-between items-center px-4 py-3 rounded-lg bg-pink-50 hover:bg-pink-100 text-pink-700 font-medium transition-colors"
              >
                <span>{cat.name}</span>
                <ChevronRight className="w-5 h-5" />
              </button>
            ) : (
              <div onClick={cerrarMenu}>
                <Link
                  href={`/es/categories/${cat.handle}`}
                  className="block px-4 py-3 rounded-lg bg-pink-50 hover:bg-pink-100 text-pink-700 font-medium transition-colors"
                >
                  {cat.name}
                </Link>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default CatalogoMenu
